import { Box, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import PaginationItem from "../PaginationItem/PaginationItem";

type PaginationProps = {
  onPageChange: (page: number) => void;
  currentPage: number;
  lastPage: number;
  siblingsCount: number;
  floating?: boolean;
};

export default function PaginationFooter({
  currentPage,
  lastPage,
  siblingsCount,
  onPageChange,
  floating = true,
}: PaginationProps) {
  const startPage = Math.max(1, currentPage - siblingsCount);
  const endPage = Math.min(lastPage, currentPage + siblingsCount);

  const pages: Array<number | 'ellipsis-start' | 'ellipsis-end'> = [];

  if (startPage > 1) {
    pages.push(1);
    if (startPage > 2) {
      pages.push('ellipsis-start');
    }
  }

  for (let page = startPage; page <= endPage; page += 1) {
    pages.push(page);
  }

  if (endPage < lastPage) {
    if (endPage < lastPage - 1) {
      pages.push('ellipsis-end');
    }
    pages.push(lastPage);
  }

  const container = (
    <Stack direction="row" justify="flex-end" align="center" spacing="6">
      <Stack direction="row" spacing="4">
        {pages.map((page, index) => {
          if (page === 'ellipsis-start' || page === 'ellipsis-end') {
            return (
              <Text color="gray.300" w="8" textAlign="center" key={`${page}-${index}`}>
                ...
              </Text>
            );
          }

          return (
            <PaginationItem
              onPageChange={onPageChange}
              page={page}
              key={page}
              isCurrent={page === currentPage}
            />
          );
        })}
      </Stack>
    </Stack>
  );

  const bg = useColorModeValue('white', 'navy.700');
  const shadow = useColorModeValue('lg', 'dark-lg');

  if (!floating) {
    return (
      <Box mt="8" paddingInline={{ base: 3, md: 0 }}>
        {container}
      </Box>
    );
  }

  return (
    <Box
      position="fixed"
      bottom={{ base: 6, md: 8 }}
      right={{ base: 4, md: 8 }}
      zIndex="sticky"
      bg={bg}
      borderRadius="full"
      boxShadow={shadow}
      px={4}
      py={2}
    >
      {container}
    </Box>
  );
}
